import { useIntl } from 'react-intl'
import React, { useMemo } from 'react'

import { buildSearchParamsFromFilters } from 'lib/search/searchUtils'
import offerPageURL from 'lib/offer/offerPageURL'
import { urlHashDatePicker } from 'constants/url'
import TextLink from 'LuxKit/TextLink'
import BodyText from 'LuxKit/Typography/BodyText'
import styled from 'styled-components'

const Container = styled.div`
  text-align: right;
  white-space: nowrap;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
`

interface Props {
  offer: App.Offer | App.Tours.TourV2Offer | App.OfferSummary | App.BedbankOffer | App.BedbankOfferSummary
  filters?: App.OfferListFilters
  className?: string
}

function SoldOutMessage({ offer, filters, className }: Props) {
  const intl = useIntl()
  const offerDatePickerUrl = useMemo(() => {
    const searchParams = buildSearchParamsFromFilters({
      ...(filters ?? {}),
      checkIn: undefined,
      checkOut: undefined,
    })
    return offerPageURL(offer, searchParams) + urlHashDatePicker
  }, [filters, offer])
  const soldOut = 'isSoldOut' in offer && offer.isSoldOut
  return <Container className={className}>
    { soldOut && <BodyText variant="large" weight="bold" align="end">{intl.formatMessage({
      id: 'TVCWinjJRV0ZxUmn4ak7',
      defaultMessage: 'Sold out',
      description: 'Status heading when an offer is sold out on the offer page',
    })}
    </BodyText>}
    { !soldOut && <BodyText variant="medium" weight="bold" align="end">{intl.formatMessage({
      id: 'EKxsf_55dZmXTE6A5RzN',
      defaultMessage: 'Unavailable for your dates',
      description: 'Message when offer is unavailable for the selected dates',
    })}
    </BodyText>}
    <TextLink size="medium" to={offerDatePickerUrl}>
      {intl.formatMessage({
        id: '6azsaDWMr_IqUsdrxidp',
        defaultMessage: 'View available dates',
        description: 'Link CTA to view available dates when offer is sold out or unavailable',
      })}
    </TextLink>
  </Container>
}

export default SoldOutMessage
